import { Box, Flex, Text } from '@chakra-ui/layout';
import { Button, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import React, { useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';

import PageBanner from '../../../components/pageBanner/PageBanner';
import PageContainer from '../../../components/pageContainer/PageContainer';
import { searchUserCertificates } from '../../../slice/corporateVerifierHomeSlice';

import CertificatesInfoTable from './CertificatesInfoTable';

function CorporateVerifierHome() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [currentDisplayEmail, setCurrentDisplayEmail] = useState('');
  const certificatesInfo = useSelector(state => state.corporateVerifierHome.certificatesInfo);

  const handleSubmit = async(e) => {
    e.preventDefault();
    const res = (await dispatch(searchUserCertificates(email))).payload;
    if (res.ok) {
      setCurrentDisplayEmail(email);
    }
  };

  const searchForm = (
    <Flex align='center' justify='center' flexDirection='column'>
      <Box display='flex' alignItems='center' justifyContent='center'>
        <Box margin='0 10px'>
          <InputGroup>
            <InputLeftElement pointerEvents='none'>
              <AiOutlineSearch color='gray.300' />
            </InputLeftElement>
            <Input placeholder='Email' onChange={e => setEmail(e.target.value)} icon='search' onSubmit={handleSubmit}/>
          </InputGroup>
        </Box>
        <Box margin='0 10px'>
          <Button backgroundColor='#007bff' color='white' _hover={{ bg: '#0069d9' }} type='submit' onClick={handleSubmit}>Submit</Button>
        </Box>
      </Box>
      <Text style={{ visibility: currentDisplayEmail ? '' : 'hidden' }} fontWeight={600}>
        Currently viewing <u>{currentDisplayEmail}</u>&apos;s certificates
      </Text>
    </Flex>
  );

  return (
    <PageContainer>
      <PageBanner/>
      {searchForm}
      <Flex margin='10px 0' justifyContent='center' className='verifier-cert-info-table'>
        <CertificatesInfoTable certificatesInfo={certificatesInfo}/>
      </Flex>
    </PageContainer>
  );
}

export default CorporateVerifierHome;
